import React from 'react';
import '../../containers/MethodologyContainer/CurrentMethodology/AddIndicatorCharacteristicModal/styles/containerAddIndicatorCharacteristicModal.style.scss';
import SimpleModal from '../simpleModal/simpleModal';
import STTypo from '../typo/STTypo';
import { TypeOptions, ColorOptions } from '../typo/STTypo.models';
import { Input } from 'antd';
import './styles/clusterHeaderModal.style.scss';
import BodyClusterModal from './bodyClusterModal';
import { useModalCluster, useClusterModalComponents } from './clusterModal.hooks';
import { MethodologyCluster } from '../../redux/methodologyCluster/models';
import { PhenomenonIdTuple } from './clusterModal.models';

export interface ClusterModalProps {
  cluster?: MethodologyCluster;
  phenomenonIds: PhenomenonIdTuple;
  isVisible: boolean;
  selectedKeys?: string[];
  onClose: () => void;
}

const ClusterModal: React.FC<ClusterModalProps> = ({ cluster, phenomenonIds, isVisible, selectedKeys, onClose }) => {
  const { components } = useClusterModalComponents({ phenomenonIds, clusterId: cluster?.id });
  const { clusterName, setClusterName, modalTitle, columns, parsedComponents, handleSubmit, isNameInUse } = useModalCluster({
    cluster,
    phenomenonUniqueId: phenomenonIds[0],
    phenomenonId: phenomenonIds[1],
    components,
    onClose
  });

  return (
    <SimpleModal title={modalTitle} visible={isVisible} width={740} onCancel={onClose}>
      <div className='cluster-header-modal-content'>
        <STTypo type={TypeOptions.P1}>Clusters group characteristics to enable custom data input in Scouting.</STTypo>
        <div className='cluster-header-modal-content__input'>
          <label htmlFor='cluster-name'>
            <STTypo color={ColorOptions.DANGER}>*</STTypo>
            <STTypo color={ColorOptions.PRIMARY}>Cluster name:</STTypo>
          </label>
          <Input
            name='cluster-name'
            id='cluster-name'
            value={clusterName}
            placeholder='Select a name'
            onChange={e => {
              setClusterName(e.target.value);
            }}
          />
          {isNameInUse && (
            <STTypo type={TypeOptions.P2} color={ColorOptions.DANGER}>
              This cluster name is already in use. Please choose a different name.
            </STTypo>
          )}
        </div>
      </div>
      <BodyClusterModal
        components={parsedComponents}
        columns={columns}
        selectedKeys={selectedKeys}
        onSubmit={selectedRowKeys => {
          handleSubmit(selectedRowKeys);
        }}
        onCancel={onClose}
        hasClusterName={Boolean(clusterName.trim()) && !isNameInUse}
        loading={false}
        clusterId={cluster?.id}
      />
    </SimpleModal>
  );
};

export default ClusterModal;
